import Axios from 'axios';
import {ajaxError401, } from '../util/util';

Axios.interceptors.response.use(response => {
  if (process.env.VUE_ENV === 'server') {
    if (response.code) {
      return response;
    } else if (response.data.code) {
      return response.data;
    }
  } else {
    return response.data;
  }
}, error => {
  if (process.env.VUE_ENV === 'server') {
    return error;
  } else {
    if (error.response) {
      if (error.response.status == 401) {
        ajaxError401();
      }
      var code = { ...error.response.data, };
      if (error.response) {
        code.code = error.response.status;
      } else {
        code.code = 501;
      }
      var str = error + '';
      if (self.searchCondition.pageNo === 1) {
        if (str.search('timeout') !== -1) { // 超时error捕获
          code.code = 600;
        }
      }
    }
    return error;
  }
});
if(process.env.VUE_ENV == 'server'){
  let env = process.env.PROJECT_ENV;
  console.log('axiosEnv',  process.env.VUE_ENV, env)
  Axios.defaults.baseURL = env==='production'?'https://zmelo.com':env==='testing'?'https://zmelotest.gooeto.com':env==='development'?'https://zmelodev.gooeto.com':'https://zmelo.com'
}
// 超时时间
// Axios.defaults.timeout = 5000;
Axios.defaults.withCredentials = true;
export const axios = Axios;
const tokenName = process.env.IH_AREA === 'hunan' ? 'token_hunan' : 'token';

export const $getHospitalDetail = async (url, params = {}, header) => {
  axios.defaults.withCredentials = true;
  let [ newparams, obj, nextUrl, ] = [ {}, {}, '', ];
  if (url.indexOf('?') != -1) { // 说明后面有参数
    url.split('?')[1].split('&').map(item => { obj[item.split('=')[0]] = item.split('=')[1]; });
    newparams = Object.assign({}, obj, params);
    url = url.split('?')[0];
  } else {
    newparams = Object.assign({}, params);
  }
  for (let key in newparams) { nextUrl += `${key}=${newparams[key]}&`; };
  if (nextUrl != '')nextUrl = '?' + nextUrl.slice(0, nextUrl.length - 1);
  try {
    let res = await axios({
      method: 'get',
      url: url + nextUrl,
      headers: {},
    });
    return res;
  } catch (e) {
    if (process.env.VUE_ENV != 'server' && process.env.NODE_ENV !== 'production') {
      console.log(url, params, e);
    }
    return e;
  }
};

export const $get = async (url, params = {}, header) => {
  axios.defaults.withCredentials = true;
  let [ newparams, obj, nextUrl, ] = [ {}, {}, '', ];
  if (url.indexOf('?') != -1) { // 说明后面有参数
    url.split('?')[1].split('&').map(item => { obj[item.split('=')[0]] = item.split('=')[1]; });
    newparams = Object.assign({}, obj, params);
    url = url.split('?')[0];
  } else {
    newparams = Object.assign({}, params);
  }
  for (let key in newparams) { nextUrl += `${key}=${newparams[key]}&`; };
  if (nextUrl != '')nextUrl = '?' + nextUrl.slice(0, nextUrl.length - 1);
  let headers = {};
  try {
    if (header && header.headers && process.env.VUE_ENV === 'server') headers = JSON.parse(header.headers);
    if (process.env.VUE_ENV !== 'server' && $.cookie(tokenName)) {
      headers = {Authorization: 'Bearer ' + $.cookie(tokenName), };
    }
    let res = await axios({
      method: 'get',
      url: url + nextUrl,
      headers,
    });
    return res;
  } catch (e) {
    if (process.env.VUE_ENV != 'server' && process.env.NODE_ENV !== 'production') {
      console.log(url, params, e);
    }
    return e;
  }
};

export const $post = async (url, params = {}, header) => {
  axios.defaults.withCredentials = true;
  let headers = {};
  try {
    if (header && header.headers && process.env.VUE_ENV === 'server') headers = JSON.parse(header.headers);
    if (process.env.VUE_ENV !== 'server' && $.cookie(tokenName)) {
      headers = {Authorization: 'Bearer ' + $.cookie(tokenName), };
    }
    let res = await axios({
      method: 'post',
      url: url,
      data: params,
      headers: headers,
    });
    return res;
  } catch (e) {
    if (process.env.VUE_ENV != 'server' && process.env.NODE_ENV !== 'production') {
      console.log(url, params, e);
    }
    return e;
  }
};
export const $put = async (url, params = {}, header) => {
  axios.defaults.withCredentials = true;
  let headers = {};

  try {
    if (header && header.headers && process.env.VUE_ENV === 'server') headers = JSON.parse(header.headers);
    if (process.env.VUE_ENV !== 'server' && $.cookie(tokenName)) {
      headers = {Authorization: 'Bearer ' + $.cookie(tokenName), };
    }
    let [ newparams, obj, nextUrl, ] = [ {}, {}, '', ];
    if (url.indexOf('?') != -1) { // 说明后面有参数
      url.split('?')[1].split('&').map(item => { obj[item.split('=')[0]] = item.split('=')[1]; });
      newparams = Object.assign({}, obj, params);
      url = url.split('?')[0];
    } else {
      newparams = Object.assign({}, params);
    }




    let res = await axios({
      method: 'post',
      url: url,
      data: newparams,
      headers,
    });
    return res;
  } catch (e) {
    if (process.env.VUE_ENV != 'server' && process.env.NODE_ENV !== 'production') {
      console.log(url, params, e);
    }
    return e;
  }
};

export const $delete = async (url, params = {}, header) => {
  let token = process.env.VUE_ENV === 'server' ? process.env.token : $.cookie(tokenName);
  axios.defaults.withCredentials = true;
  let headers = {};
  if (process.env.VUE_ENV === 'server') headers = JSON.parse(process.env.headers);
  try {
    if (header && header.headers && process.env.VUE_ENV === 'server') headers = JSON.parse(header.headers);
    if (process.env.VUE_ENV !== 'server' && $.cookie(tokenName)) {
      headers = {Authorization: 'Bearer ' + $.cookie(tokenName), };
    }
    let res = await axios({
      method: 'post',
      url: url,
      data: params,
      headers,
    });
    return res;
  } catch (e) {
    if (process.env.VUE_ENV != 'server' && process.env.NODE_ENV !== 'production') {
      console.log(url, params, e);
    }
    return e;
  }
};

export const $upload = (url, params = {}, obj) => {
  axios.defaults.withCredentials = true;
  axios.post(url, params, {
    onUploadProgress: progressEvent => {
      var complete = (progressEvent.loaded / progressEvent.total * 100 | 0) + '%';
      obj.proress && obj.proress(complete);
    },
  }).then(res => {
    obj.success && obj.success(res);
  }).catch(res => {
    obj.fail && obj.fail(res);
  });
};



// WEBPACK FOOTER //
// src/others/ajax.js